import { IconClose } from "./ServiceCardIcons";

function DeleteServicePopup({ service, pending, error, onCancel, onConfirm }) {
  if (!service) return null;

  return (
    <div
      className="ls-pop-overlay"
      onClick={() => {
        if (!pending) onCancel();
      }}
      role="alertdialog"
      aria-modal="true"
      aria-label="تأیید حذف سرویس"
    >
      <div className="ls-pop ls-pop--narrow" dir="rtl" onClick={(e) => e.stopPropagation()}>
        <div className="ls-pop__header">
          <span className="ls-pop__title">حذف سرویس</span>
          <button type="button" className="ls-pop__close" aria-label="بستن" disabled={pending} onClick={onCancel}>
            <IconClose />
          </button>
        </div>
        <div className="ls-pop__body">
          <div className="ls-pop__confirm-text">آیا از حذف این سرویس مطمئن هستید؟</div>
          <div className="ls-pop__confirm-sub">{service.displayType}</div>
          {error && <div className="ls-pop__error">{error}</div>}
        </div>
        <div className="ls-pop__actions">
          <button
            type="button"
            className="completed-card__btn completed-card__btn--delete"
            disabled={pending}
            onClick={onConfirm}
          >
            {pending ? "در حال حذف..." : "بله، حذف شود"}
          </button>
          <button
            type="button"
            className="completed-card__btn completed-card__btn--cancel"
            disabled={pending}
            onClick={onCancel}
          >
            انصراف
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteServicePopup;
